import * as React from 'react'

import { View, type ViewProps } from 'react-native'

import clx from 'classnames'

interface StackProps extends ViewProps {
	gap?: number
	fullHeight?: boolean
	fullWidth?: boolean
}

/**
 * Shorthand for flexbox items in a row by auto-assigning flex-row via nativewind class
 */
const HStack = React.forwardRef<React.ElementRef<typeof View>, StackProps>(
	({ className, gap, fullHeight, fullWidth, ...props }, ref) => {
		return (
			<View
				ref={ref}
				className={clx(
					'flex-row',
					fullHeight ? 'h-full' : '',
					fullWidth ? 'w-full' : '',
					className
				)}
				{...props}
				style={[{ gap }, props.style]}
			/>
		)
	}
)

HStack.displayName = 'HStack'

/**
 * Shorthand for flexbox items in a column by auto-assigning flex-row via nativewind class
 */
const VStack = React.forwardRef<React.ElementRef<typeof View>, StackProps>(
	({ className, gap, fullHeight, fullWidth, ...props }, ref) => {
		return (
			<View
				ref={ref}
				className={clx(
					'flex-col',
					fullHeight ? 'h-full' : '',
					fullWidth ? 'w-full' : '',
					className
				)}
				{...props}
				style={[{ gap }, props.style]}
			/>
		)
	}
)

VStack.displayName = 'VStack'

export { HStack, VStack }
